import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';

@Component({
  selector: 'app-modal-yes-no',
  templateUrl: './modal-yes-no.component.html',
  styleUrls: ['./modal-yes-no.component.css']
})
export class ModalYesNoComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  question: string = '';

  constructor(public catalogueService: CatalogueService, private ngbActiveModal: NgbActiveModal) { }

  setOption(option) {
    this.ngbActiveModal.close(option);
  }

  ngOnInit() {
  }

}
